import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/config-global';

import { Label } from 'src/components/label';
import { Iconify } from 'src/components/iconify';
import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`${CONFIG.site.basePath}/assets/icons/navbar/${name}.svg`} />;

const ICONS = {
  job: icon('ic-job'),
  blog: icon('ic-blog'),
  chat: icon('ic-chat'),
  mail: icon('ic-mail'),
  user: icon('ic-user'),
  file: icon('ic-file'),
  lock: icon('ic-lock'),
  tour: icon('ic-tour'),
  order: icon('ic-order'),
  label: icon('ic-label'),
  blank: icon('ic-blank'),
  kanban: icon('ic-kanban'),
  folder: icon('ic-folder'),
  course: icon('ic-course'),
  banking: icon('ic-banking'),
  booking: icon('ic-booking'),
  invoice: icon('ic-invoice'),
  product: icon('ic-product'),
  calendar: icon('ic-calendar'),
  disabled: icon('ic-disabled'),
  external: icon('ic-external'),
  menuItem: icon('ic-menu-item'),
  ecommerce: icon('ic-ecommerce'),
  analytics: icon('ic-analytics'),
  dashboard: icon('ic-dashboard'),
  parameter: icon('ic-parameter'),
  summary: icon('icon-resumo'),
  portfolio: icon('icon-portfolio'),
};

// ----------------------------------------------------------------------

export const navData = [
  /**
   * Management
   */
  {
    subheader: 'Gerenciamento',
    items: [
      {
        title: 'Meu resumo',
        path: paths.dashboard.my_summary,
        icon: ICONS.summary,
        disabled: false,
      },
      {
        title: 'Agendamentos',
        path: paths.dashboard.calendar,
        icon: ICONS.calendar,
        disabled: false,
      },
      {
        title: 'Combos e Serviços',
        path: paths.dashboard.establishment_packages_services,
        icon: ICONS.order,
        disabled: false,
      },
      { title: 'Clientes', path: paths.dashboard.clients, icon: ICONS.portfolio, disabled: false },
      {
        title: 'Profissionais',
        path: paths.dashboard.manage_partner_professionals,
        icon: ICONS.user,
        disabled: false,
      },
      {
        title: 'Produtos',
        path: paths.dashboard.product.root,
        icon: ICONS.ecommerce,
        disabled: false,
        children: [
          { title: 'Produtos', path: paths.dashboard.product.root },
          { title: 'Criar produto', path: paths.dashboard.product.new },
        ],
      },
      {
        title: 'Página do negócio',
        path: paths.dashboard.portfolio,
        icon: ICONS.portfolio,
        disabled: false,
      },
      {
        title: 'Horário de atendimento',
        path: paths.dashboard.opening_hours,
        icon: ICONS.job,
        disabled: false,
      },
      {
        title: 'Financeiro',
        path: paths.dashboard.financial_home,
        icon: ICONS.invoice,
        disabled: false,
        children: [
          { title: 'Financeiro', path: paths.dashboard.financial_home },
          { title: 'Fluxo de Caixa', path: paths.dashboard.financial_cash_flow },
          { title: 'Relatórios e Indicadores', path: paths.dashboard.financial_report },
        ],
      },
      { title: 'Meu plano', path: paths.dashboard.plans, icon: ICONS.ecommerce, disabled: false },
      { title: 'Suporte', path: paths.dashboard.help, icon: ICONS.menuItem },
    ],
  },
];

export const navDataClient = [
  {
    subheader: 'Gerenciamento',
    items: [
      { title: 'Agendamentos', path: paths.dashboard.calendar_client, icon: ICONS.calendar, disabled: false },
      { title: 'Suporte', path: paths.dashboard.help, icon: ICONS.menuItem }
    ],
  },
];

export const navDataProfessional = [
  {
    subheader: 'Gerenciamento',
    items: [
      { title: 'Agendamentos', path: paths.dashboard.calendar, icon: ICONS.calendar, disabled: false },
    ],
  },
];
